import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, Phone, Mail } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSections = [
    {
      title: "Questions sur les Garanties et Contrôle Technique",
      questions: [
        {
          q: "Les garanties constructeur sont-elles affectées par l'installation du kit Ecopra ?",
          a: "Les garanties constructeur de votre véhicule restent valides avec le kit Ecopra, car il respecte les normes des fabricants. De plus, il est conforme aux réglementations en vigueur pour le contrôle technique suisse et ne présente aucune contre-indication."
        },
        {
          q: "Dois-je attendre la fin de ma garantie constructeur avant d'installer le kit Ecopra ?",
          a: "Non, vous pouvez l'installer dès maintenant. En effet, le kit Ecopra est compatible avec les véhicules sous garantie, car il respecte les normes des constructeurs."
        },
        {
          q: "Le voyant moteur est allumé, votre système répare la voiture ?",
          a: "⚠️ Si le voyant moteur s'allume, faites vérifier votre véhicule par un professionnel. Le kit ne répare pas les véhicules !",
          warning: true
        }
      ]
    },
    {
      title: "Compatibilité du Kit Ecopra",
      questions: [
        {
          q: "Le kit Ecopra est-il compatible avec les véhicules essence, diesel ou biocarburant ?",
          a: "Oui, il est compatible avec les moteurs essence, diesel, GNR, éthanol, gaz et hydrogène. Vous pouvez l'installer sur la majorité des moteurs thermiques."
        },
        {
          q: "Puis-je installer le kit Ecopra sur un véhicule de collection ?",
          a: "Oui, il est possible de l'adapter aux véhicules de collection, après une évaluation technique."
        },
        {
          q: "Est-il compatible avec les véhicules en LOA ou leasing ?",
          a: "Vous devez vérifier les conditions de votre contrat de LOA. En général, une autorisation de la société de leasing est requise."
        },
        {
          q: "Fonctionne-t-il avec les véhicules à boîte automatique ?",
          a: "Absolument, il est compatible avec les boîtes automatiques."
        },
        {
          q: "Est-il adapté aux véhicules hybrides ?",
          a: "Principalement conçu pour les moteurs thermiques, il peut s'adapter aux hybrides après évaluation."
        }
      ]
    },
    {
      title: "Utilisation et Installation du Kit Ecopra",
      questions: [
        {
          q: "Puis-je installer le kit Ecopra moi-même ?",
          a: "Oui ! Le kit est conçu pour être installé par un particulier ayant des compétences de base en mécanique. L'installation est simple en elle-même, mais sa difficulté dépend principalement de l'accès à l'admission d'air sur votre véhicule (variable selon les modèles). Outillage nécessaire : foret étagé, tournevis, cliquet et jeu de douilles. Un guide de montage illustré est fourni avec chaque kit. Si vous préférez, vous pouvez aussi faire appel à un installateur professionnel agréé Ecopra en Suisse."
        },
        {
          q: "Comment installer le kit sur mon véhicule ou ma chaudière ?",
          a: "Vous avez deux options : installation par un professionnel agréé Ecopra en Suisse ou installation en autonomie avec un accompagnement en visio ou par téléphone."
        },
        {
          q: "Puis-je faire installer le kit par un professionnel ?",
          a: "Oui, nous vous recommandons de faire appel à un installateur expérimenté pour une installation optimale. Contactez-nous pour trouver un installateur agréé près de chez vous en Suisse."
        },
        {
          q: "Combien de carburant puis-je économiser ?",
          a: "En moyenne, vous économiserez entre 15% et 35% de carburant, selon votre véhicule et votre conduite."
        },
        {
          q: "Le kit réduit-il les émissions polluantes ?",
          a: "Oui, il réduit jusqu'à 80% les émissions de gaz polluants et jusqu'à 30% les émissions de CO2."
        },
        {
          q: "Où dois-je installer le kit sur un moteur ?",
          a: "Installez-le dans la durite d'air avant le filtre à air d'origine."
        },
        {
          q: "Où s'installe-t-il sur une chaudière ?",
          a: "Il se positionne dans les ouïes d'entrée d'air avant les turbines électriques ou dans les conduits des ventouses."
        },
        {
          q: "Le kit nécessite-t-il un branchement électrique ?",
          a: "Non, il ne nécessite aucun branchement électrique ou électronique."
        },
        {
          q: "Dois-je faire un diagnostic moteur après l'installation ?",
          a: "Non, le moteur s'adapte automatiquement grâce à ses capteurs."
        },
        {
          q: "Des réglages sont-ils nécessaires ?",
          a: "Le kit fonctionne par dépression d'air du moteur. Assurez-vous qu'il est correctement positionné."
        }
      ]
    },
    {
      title: "Questions sur l'Achat, la Garantie et le Fonctionnement",
      questions: [
        {
          q: "Le kit Ecopra est-il légal en Suisse ?",
          a: "Oui, il respecte les normes de contrôle technique suisse et est conforme à la législation."
        },
        {
          q: "Comment acheter le kit Ecopra ?",
          a: "Rendez-vous dans notre Boutique pour commander votre kit. Vous bénéficierez également d'un accompagnement gratuit lors d'un rendez-vous stratégique. Prix affichés en CHF."
        },
        {
          q: "Quand pourrai-je installer mon kit après achat ?",
          a: "En général, une semaine après l'achat ou à réception du kit."
        },
        {
          q: "D'où vient le kit Ecopra ?",
          a: "Le kit Ecopra est fabriqué en France (Made in Auvergne) par SAS ECOPRA, créateur et inventeur du système depuis 2007."
        },
        {
          q: "Comment fonctionne-t-il pour économiser du carburant ?",
          a: "Le kit optimise la combustion de l'air dans le moteur, améliorant ainsi le rendement énergétique et réduisant la consommation."
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#7CB342] to-[#00BCD4] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <HelpCircle className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl sm:text-5xl font-bold mb-4">
              FAQ - Questions Fréquentes
            </h1>
            <p className="text-xl opacity-90 max-w-3xl mx-auto">
              Trouvez rapidement des réponses à vos questions sur le Kit Ecopra
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Content */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {faqSections.map((section, sectionIndex) => (
          <div key={sectionIndex} className="mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-800 border-b-4 border-[#00BCD4] pb-3">
              {section.title}
            </h2>
            <div className="space-y-4">
              {section.questions.map((item, qIndex) => {
                const globalIndex = `${sectionIndex}-${qIndex}`;
                const isOpen = openIndex === globalIndex;

                return (
                  <div
                    key={globalIndex}
                    className={`border rounded-lg transition-all duration-300 ${
                      item.warning
                        ? 'border-red-300 bg-red-50'
                        : 'border-gray-200 bg-white hover:shadow-lg'
                    }`}
                  >
                    <button
                      onClick={() => toggleFAQ(globalIndex)}
                      className="w-full flex items-center justify-between p-5 text-left"
                    >
                      <span className={`font-semibold text-lg pr-4 ${
                        item.warning ? 'text-red-700' : 'text-gray-800'
                      }`}>
                        {item.q}
                      </span>
                      <span className="flex-shrink-0">
                        {isOpen ? (
                          <ChevronUp className="w-6 h-6 text-[#00BCD4]" />
                        ) : (
                          <ChevronDown className="w-6 h-6 text-gray-400" />
                        )}
                      </span>
                    </button>

                    {isOpen && (
                      <div className={`px-5 pb-5 border-t ${
                        item.warning ? 'border-red-200' : 'border-gray-100'
                      }`}>
                        <p className={`mt-4 leading-relaxed ${
                          item.warning ? 'text-red-800' : 'text-gray-700'
                        }`}>
                          {item.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Contact CTA */}
        <div className="mt-16 bg-gradient-to-r from-[#7CB342] to-[#00BCD4] rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">
            Vous n'avez pas trouvé la réponse à votre question ?
          </h3>
          <p className="text-lg mb-6 opacity-90">
            Notre équipe est là pour vous aider. Contactez-nous !
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:+41786380203"
              className="inline-flex items-center gap-2 bg-white text-[#00BCD4] font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition-all transform hover:scale-105"
            >
              <Phone className="w-5 h-5" />
              078 638 02 03
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 bg-white text-[#7CB342] font-semibold px-6 py-3 rounded-full hover:bg-gray-100 transition-all transform hover:scale-105"
            >
              <Mail className="w-5 h-5" />
              Formulaire de contact
            </a>
          </div>
        </div>

        {/* Info Box */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start gap-3">
            <HelpCircle className="w-6 h-6 text-blue-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm text-blue-800">
              <p className="font-semibold mb-2">💡 Bon à savoir</p>
              <ul className="space-y-1 list-disc list-inside">
                <li>Tous les prix sont affichés en CHF (Francs Suisses)</li>
                <li>Installation professionnelle disponible partout en Suisse</li>
                <li>Le kit Ecopra est fabriqué en France depuis 2007</li>
                <li>Compatible avec tous types de moteurs thermiques</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
